export default __webpack_public_path__ + "static/media/hht2_direction_songtime_01.c8759aaf.jpg";